
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.723 14.63c-.05 0-.05-.051-.05-.051l-.46-6.422H.239c-.05 0-.05-.051-.05-.051V6.169s-.103-.408.05-.612a.39.39 0 01.255-.102h3.925l.05-.357c-.05 0-.152.051-.254.051h-.102c-.459 0-.612-.05-.612-.153 0-.153.459-.153.663-.153.05 0 .255 0 .357.051.05-.152.153-.458.305-.458s.204.255.255.407c.102 0 .204-.05.357-.05h.102c.459 0 .612.05.612.152 0 .153-.46.153-.663.153-.05 0-.204 0-.306-.05l.102.356h1.02c0-.102 0-.204.05-.306.052-.05.102-.05.153-.05.153 0 .306-.205.357-.306 0-.714-.05-4.282.663-4.333V.36c.713 0 .662 3.669.662 4.383.051.05.204.254.357.254.051 0 .102 0 .153.051.051.102.051.204.051.306h1.02l.101-.357c-.101 0-.254.051-.305.051-.204 0-.663 0-.663-.153 0-.101.153-.152.612-.152h.05c.154 0 .306.05.357.05.051-.152.102-.407.255-.407.153 0 .255.255.306.458.102 0 .306-.05.357-.05.204 0 .663 0 .663.152 0 .102-.153.153-.612.153h-.051c-.102 0-.255 0-.306-.05l.051.356h3.925a.39.39 0 01.255.102c.153.204.05.612.05.612v1.937c0 .05-.05.05-.05.05h-3.976l-.459 6.423c0 .05-.05.05-.05.05H4.722v.052zm5.2-1.835l-.357-4.638H8.088c-.051.305-.255 1.325-.663 1.376-.408 0-.612-1.07-.663-1.376H5.284l-.357 4.638h4.995z"}})])
          )
        }
      }
    